import Loader from "../../Loader";
import Carousel from "react-elastic-carousel";
import Item from "./Item";
import { useEffect, useState } from "react";

import "./Projects.scss";

const Work = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    async function getData() {
      const response = await fetch(`${process.env.REACT_APP_server}/projects`);
      let projects = await response.json();

      setProjects(projects);
      setIsLoading(false);
    }

    getData();

    console.log(projects);
  });

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 750, itemsToShow: 2, itemsToScroll: 2 },
    { width: 1200, itemsToShow: 3 },
    { width: 1500, itemsToShow: 4, itemsToScroll: 2 },
  ];

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div class="text-box">
            <h1 class="heading-primary">
              <span class="heading-primary-main">My Project</span>
              <span class="heading-primary-sub">web development</span>
            </h1>
          </div>
          {/* <h1 style={{ textAlign: "center" ,paddingTop:"20px"}}>My work</h1> */}
          <div className="App">
            <Carousel breakPoints={breakPoints}>
              {projects.map(
                ({ _id, name, description, live, project_image }) => (
                  <Item
                    name={name}
                    description={description}
                    live={live}
                    image={project_image}
                    id={_id}
                  />
                )
              )}
            </Carousel>
          </div>
        </>
      )}
    </>
  );
};

export default Work;
